/**
 * PROJECT-OVERVIEW §7.3 — Lançamento manual.
 *
 * Every manual entry **must** carry `provedor`, `tipo` and `origem`, because those
 * three are the grouping dimensions of the Orçamento dashboard (2i). Real cases
 * Eduardo gave: a credit that landed in the account, a broker-applied discount, and
 * Azure consumption on a multi-cloud contract — **other clouds are entered
 * manually, never integrated.**
 */
import { z } from 'zod'

import { competencia, dinheiro, id, valorDeCatalogo } from './comum'

export const lancamentoManualSchema = z.object({
  idLancamento: id,
  idCliente: id,
  /**
   * // ⚠️ assumido — §9: config hangs off the **contract**, not the client. The
   * backend has not confirmed this; if it turns out to hang off the client, every
   * lançamento screen changes its parent.
   */
  idContrato: id,
  /** `YYYY-MM`. */
  competencia,
  /**
   * `'AWS' | 'Azure' | ...` — a grouping dimension on 2i, and an open catalog: a
   * new cloud must not need a frontend deploy.
   */
  provedor: valorDeCatalogo,
  tipo: z.enum(['desconto', 'acrescimo']),
  /** vs. `'integrado'` — the other grouping dimension on 2i. */
  origem: z.enum(['manual', 'integrado']),
  valor: dinheiro,
  descricao: z.string(),
})

export type LancamentoManual = z.infer<typeof lancamentoManualSchema>
